<template>
  <div id="system-manage-email-email-template-add">
    <div class="ipub-h1 mar-b-20">Email Template Configuration</div>
    <ipub-form class="mar-b-30"
               ref="email-template-add"
               :model="params"
               :rules="rules">
      <ipub-form-item prop="subject"
                      label="Letter Subject">
        <ipub-input placeholder="Letter Subject"
                    v-model.trim="params.subject" />
      </ipub-form-item>
      <ipub-form-item prop="letterFamilyId"
                      label="Letter Family">
        <ipub-select placeholder="Letter Family"
                     :options="familyList"
                     optionKey="id"
                     @change="onChange"
                     v-model="params.letterFamilyId" />
      </ipub-form-item>
      <ipub-form-item prop="fromMail"
                      label="Sender’s Email Address">
        <div class="flex">
          <ipub-radio v-if="showData.fromSystem"
                      @change="()=>{params.fromMail = 'SYSTEM'}"
                      :checked="params.fromMail === 'SYSTEM'">System Email - General</ipub-radio>
          <ipub-radio v-if="showData.fromSystem"
                      @change="()=>{params.fromMail = 'SYSTEM_WU'}"
                      :checked="params.fromMail === 'SYSTEM_WU'">System Email - Warming Up</ipub-radio>
          <ipub-radio v-if="showData.fromJournal"
                      class="mar-l-30"
                      @change="()=>{params.fromMail = 'JOURNAL'}"
                      :checked="params.fromMail === 'JOURNAL'">Journal Email - Genera</ipub-radio>
          <ipub-radio v-if="showData.fromJournal"
                      class="mar-l-30"
                      @change="()=>{params.fromMail = 'JOURNAL_WU'}"
                      :checked="params.fromMail === 'JOURNAL_WU'">Journal Email - Warming Up</ipub-radio>
        </div>
      </ipub-form-item>
      <ipub-form-item prop="sendAddress"
                      label="Recipient">
        <div class="mar-b-10"
             v-if="showData.toJournal">
          <ipub-radio checkBox
                      @change="(e)=>{params.toJournal = !e}"
                      :checked="params.toJournal">Journal Email</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toManageEditor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toManageEditor = !e}"
                      :checked="params.toManageEditor">Manager Editor</ipub-radio>
        </div>
        <template v-if="showData.toOther">
          <div class="mar-b-10">
            <ipub-radio checkBox
                        @change="(e)=>{params.toOther = !e}"
                        :checked="params.toOther">Display the following e-mail address for the recipient</ipub-radio>
          </div>
          <div class="mar-b-10">
            <ipub-input v-model.trim="params.toOtherMail"
                        placeholder="Enter Email Address" />
          </div>
        </template>
        <div class="mar-b-10"
             v-if="showData.toDisplay">
          <ipub-radio checkBox
                      @change="(e)=>{params.toDisplay = !e}"
                      :checked="params.toDisplay">Display text box so sender can insert an e-mail address</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toFirstEditor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toFirstEditor = !e}"
                      :checked="params.toFirstEditor">First Assigned Editor</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toProcessEditor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toProcessEditor = !e}"
                      :checked="params.toProcessEditor">Assigned Editor</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toReviewer">
          <ipub-radio checkBox
                      @change="(e)=>{params.toReviewer = !e}"
                      :checked="params.toReviewer">All Reviewers of the current revision of the submission (Send it Seperately)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toEditorBoard">
          <ipub-radio checkBox
                      @change="(e)=>{params.toEditorBoard = !e}"
                      :checked="params.toEditorBoard">Editorial Board</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toAllGuestEditor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toAllGuestEditor = !e}"
                      :checked="params.toAllGuestEditor">Guest Editors (Send together)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toGuestEditor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toGuestEditor = !e}"
                      :checked="params.toGuestEditor">Guest Editors (spearate delivery)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toCorrAuthor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toCorrAuthor = !e}"
                      :checked="params.toCorrAuthor">Corresponding Author</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toAllCoAuthor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toAllCoAuthor = !e}"
                      :checked="params.toAllCoAuthor">Co-Author (Send together)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toCoAuthor">
          <ipub-radio checkBox
                      @change="(e)=>{params.toCoAuthor = !e}"
                      :checked="params.toCoAuthor">Co-Author (spearate delivery)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toEmployee">
          <ipub-radio checkBox
                      @change="(e)=>{params.toEmployee = !e}"
                      :checked="params.toEmployee">Employee</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toSubmitter">
          <ipub-radio checkBox
                      @change="(e)=>{params.toSubmitter = !e}"
                      :checked="params.toSubmitter">Submitter</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toOperator">
          <ipub-radio checkBox
                      @change="(e)=>{params.toOperator = !e}"
                      :checked="params.toOperator">Operator</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.toSpecialApplicator">
          <ipub-radio checkBox
                      @change="(e)=>{params.toSpecialApplicator = !e}"
                      :checked="params.toSpecialApplicator">Applicant for Special Issue</ipub-radio>
        </div>
      </ipub-form-item>
      <ipub-form-item prop="replyTo"
                      label="Email for Reply">
        <div class="flex">
          <ipub-radio v-if="showData.replyPublisher"
                      @change="()=>{params.replyTo = 'PUBLISHER'}"
                      :checked="params.replyTo === 'PUBLISHER'">Publisher Email</ipub-radio>
          <ipub-radio v-if="showData.replyJournal"
                      class="mar-l-30"
                      @change="()=>{params.replyTo = 'LOGIN_USER'}"
                      :checked="params.replyTo === 'LOGIN_USER'">Account Email</ipub-radio>
          <ipub-radio v-if="showData.replyProcessEditor"
                      class="mar-l-30"
                      @change="()=>{params.replyTo = 'PROCESS_EDITOR'}"
                      :checked="params.replyTo === 'PROCESS_EDITOR'">Assigned Editor</ipub-radio>
        </div>
      </ipub-form-item>

      <ipub-form-item prop="sendAddress"
                      label="Additional Recipients">
        <div class="ipub-p4 mar-b-10">
          Recipients of a cc : copy will be revealed to and able to see the sender , the primary recipient(s) and any cc : recipients<br />
          Recipients of a bcc : copy will not be revealed to any other recipients , but will be revealed to the sender and able to see the sender, the primary recipient(s) and any cc : recipients
        </div>
        <div class="mar-b-10 flex">
          <span class="ipub-p3">Automatically CC</span>
          <ipub-radio v-if="showData.ccCoAuthor"
                      class="mar-l-30"
                      @change="(e)=>{params.ccCoAuthor = !e}"
                      :checked="params.ccCoAuthor"
                      checkBox>All Co-Authors</ipub-radio>
          <ipub-radio v-if="showData.ccProcessEditor"
                      class="mar-l-30"
                      @change="(e)=>{params.ccProcessEditor = !e}"
                      :checked="params.ccProcessEditor"
                      checkBox>Assigned Editor</ipub-radio>
          <ipub-radio v-if="showData.ccManageEditor"
                      class="mar-l-30"
                      @change="(e)=>{params.ccManageEditor = !e}"
                      :checked="params.ccManageEditor"
                      checkBox>Managing Editor</ipub-radio>
          <ipub-radio v-if="showData.ccJournal"
                      class="mar-l-30"
                      @change="(e)=>{params.ccJournal = !e}"
                      :checked="params.ccJournal"
                      checkBox>Journal Email</ipub-radio>
        </div>
        <div class="mar-b-10 flex">
          <span class="ipub-p3">Automatically BCC</span>
          <ipub-radio v-if="showData.bccCoAuthor"
                      class="mar-l-30"
                      @change="(e)=>{params.bccCoAuthor = !e}"
                      :checked="params.bccCoAuthor"
                      checkBox>All Co-Authors</ipub-radio>
          <ipub-radio v-if="showData.bccProcessEditor"
                      class="mar-l-30"
                      @change="(e)=>{params.bccProcessEditor = !e}"
                      :checked="params.bccProcessEditor"
                      checkBox>Assigned Editor</ipub-radio>
          <ipub-radio v-if="showData.bccManageEditor"
                      class="mar-l-30"
                      @change="(e)=>{params.bccManageEditor = !e}"
                      :checked="params.bccManageEditor"
                      checkBox>Managing Editor</ipub-radio>
          <ipub-radio v-if="showData.bccJournal"
                      class="mar-l-30"
                      @change="(e)=>{params.bccJournal = !e}"
                      :checked="params.bccJournal"
                      checkBox>Journal Email</ipub-radio>
        </div>
      </ipub-form-item>

      <ipub-form-item v-if="showData.ccOther||showData.bccOther"
                      prop="sendAddress"
                      label="Send Copies to the Following Address">
        <div class="mar-b-10 flex-center"
             v-if="showData.ccOther">
          <div class="line-h-40"
               style="width: 80px">
            <ipub-radio checkBox
                        @change="(e)=>{params.ccOther = !e}"
                        :checked="params.ccOther">CC</ipub-radio>
          </div>
          <div style="width: calc(100% - 80px)">
            <ipub-input style="width:100%"
                        placeholder="Multiple address can be entered; Please separted bya semicoion"
                        v-model.trim="params.ccOtherMail" />
          </div>
        </div>
        <div class="mar-b-10 flex-center"
             v-if="showData.bccOther">
          <div class="line-h-40"
               style="width: 80px">
            <ipub-radio checkBox
                        @change="(e)=>{params.bccOther = !e}"
                        :checked="params.bccOther">BCC</ipub-radio>
          </div>
          <div style="width: calc(100% - 80px)">
            <ipub-input style="width:100%"
                        placeholder="Multiple address can be entered; Please separted bya semicoion"
                        v-model.trim="params.bccOtherMail" />
          </div>
        </div>
      </ipub-form-item>
      <ipub-form-item v-if="showData.ccDisplay||showData.bccDisplay"
                      label="Display email entry box on 'Send Letter' page">
        <div class="mar-b-10"
             v-if="showData.ccDisplay">
          <ipub-radio checkBox
                      @change="(e)=>{params.ccDisplay = !e}"
                      :checked="params.ccDisplay">CC : ( Allow sender to manually enter CC : recipients)</ipub-radio>
        </div>
        <div class="mar-b-10"
             v-if="showData.bccDisplay">
          <ipub-radio checkBox
                      @change="(e)=>{params.bccDisplay = !e}"
                      :checked="params.bccDisplay">BCC : ( Allow sender to manually enter BCC : recipients)</ipub-radio>
        </div>
      </ipub-form-item>
      <ipub-form-item v-if="showData.allowAttach"
                      prop="allowAttach"
                      label="Attachment">
        <ipub-radio-group class="mar-b-10"
                          v-model="params.allowAttach"
                          _label="name"
                          :options="[{name:'Not Allowed',value:false},{name:'Allowed',value:true}]" />
      </ipub-form-item>
      <div class="ipub-p3 mar-b-10 relative">
        Letter Body
        <a class="right-option link-color"
           @click="insert">Insert Variable</a>
      </div>
      <ipub-editor :height="500"
                   v-model.trim="params.body" />
    </ipub-form>
    <div class="ipub-p1">
      <!-- <ipub-button style="width:150px"
                   @click="()=>{$router.back(-1)}"
                   plain
                   type="primary">Cancel</ipub-button> -->
      <ipub-button style="width:150px"
                   @click="save(false)"
                   plain
                   type="primary">Save</ipub-button>
      <ipub-button v-if="!params.id"
                   style="width:150px"
                   @click="save(true)"
                   type="primary">Submit</ipub-button>
    </div>
    <Insert :isVisable="show"
            @cancel="cancel"
            @confirm="confirm" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
